export default __webpack_public_path__ + "static/media/app.45cd574f.png";